/** @jsx jsx */
import { css, jsx } from '@emotion/core'
import { HFlow, Icon, Modal, ModalBody, Text, VFlow } from 'bold-ui'
import { SdcSecaoAccordion } from 'hooks/sdc/components/SdcSecaoAccordion'
import { conjuntoFatoresVerificadosPreEclampsiaSdc } from 'hooks/sdc/model-sdc'

import { ReactComponent as SdcIcon } from '../../../../../../images/suporte-decisao-clinica/health-system-outline.svg'
import { RiscoPreEclampsiaTag } from './RiscoPreEclampsiaTag'

interface SdcCondutaModalProps {
  modalOpen: boolean
  setModalOpen(boolean): void
}

export function SdcFatoresRiscoPreEclampsiaModal(props: Readonly<SdcCondutaModalProps>) {
  const { modalOpen, setModalOpen } = props

  const handleModalClose = () => {
    setModalOpen(false)
  }

  return (
    <Modal open={modalOpen} onClose={handleModalClose} style={styles.modal}>
      <ModalBody>
        <VFlow vSpacing={1.5}>
          <VFlow>
            <HFlow alignItems='center'>
              <Icon icon={SdcIcon} size={2.5} />
              <Text variant='h1' fontWeight='bold'>
                Fatores de risco para pré-eclâmpsia
              </Text>
            </HFlow>
            <Text variant='h5' fontWeight='normal'>
              O Suporte à Decisão Clínica identifica o risco de pré-eclâmpsia com base nos dados do prontuário. Alguns
              fatores indicam risco isoladamente, enquanto outros são considerados em conjunto com mais de um critério.{' '}
              <Text variant='h5' fontWeight='bold'>
                Para garantir uma avaliação precisa, verifique se os fatores de risco estão devidamente registrados no
                prontuário eletrônico.
              </Text>
            </Text>
            <VFlow vSpacing={0.25}>
              <Text variant='h5' fontWeight='bold'>
                Risco de pré-eclâmpsia
              </Text>
              <RiscoPreEclampsiaTag />
            </VFlow>
          </VFlow>
          <SdcSecaoAccordion conjuntoFatoresSdc={conjuntoFatoresVerificadosPreEclampsiaSdc} />
        </VFlow>
      </ModalBody>
    </Modal>
  )
}

const styles = {
  modal: css`
    height: 100%;
    overflow-y: auto;
    scrollbar-gutter: stable;
  `,
}
